import React, { PropsWithChildren, useState } from "react";
import styles from "./CollapsibleBox.module.scss";
import dropdown from "../../../../assets/dropdown.svg";
import SVG from "react-inlinesvg";
import classnames from "classnames";

interface CollapsibleBoxProps {
  isDropdown?: boolean;
  title: string;
  isCustom?: boolean;
}

export const CollapsibleBox: React.FC<
  CollapsibleBoxProps & PropsWithChildren
> = ({ children, isDropdown = false, isCustom = false, title }) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const cx = classnames.bind(styles);
  const handleOnClick = (e: any) => {
    if (isDropdown && isCollapsed) {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      setIsCollapsed(!isCollapsed);
    }
  };
  return (
    <div
      className={cx(
        styles.CollapsibleBox,
        isDropdown ? styles.isDropdown : styles.unset
      )}
      onClick={handleOnClick}
    >
      {isDropdown && (
        <div
          onClick={(e: any) => {
            if (isDropdown) {
              e.preventDefault();
              setIsCollapsed(!isCollapsed);
            }
          }}
          className={cx(
            styles.dropdown,
            isCollapsed ? styles.isCollapsed : styles.isExpanded
          )}
        >
          <SVG src={dropdown} />
        </div>
      )}
      {isCollapsed && <label className={styles.label}>{title} </label>}
      <div
        className={cx(
          isCollapsed ? styles.isCollapsed : styles.isExpanded,
          isCustom ? styles.isCustom : styles.unset
        )}
      >
        {children}
      </div>
    </div>
  );
};
